<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<span [ngClass]="containerCls"
      [title]="description"
      class="slds-icon_container">
  <svg [ngClass]="iconClasses" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <ng-container [ngSwitch]="iconName">
      <ng-container *ngSwitchCase="'chevronleft'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
          <path
            d="M15.8 22l-9.6-9.4c-.3-.3-.3-.8 0-1.1l9.6-9.4c.3-.3.7-.3 1 0l1 1c.3.3.3.7 0 1l-7.6 7.4c-.3.3-.3.8 0 1.1l7.5 7.4c.3.3.3.7 0 1l-1 1c-.2.2-.6.2-.9 0z"/>
        </svg>
      </ng-container>
      <ng-container *ngSwitchCase="'chevronright'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
          <path
            d="M8.3 2l9.5 9.5c.3.3.3.7 0 1L8.3 22c-.3.2-.8.2-1.1 0l-1-1c-.2-.3-.2-.8 0-1.1l7.6-7.4c.2-.3.2-.7 0-1L6.3 4.1C6 3.8 6 3.3 6.3 3l1-1c.3-.2.7-.2 1 0z"/>
        </svg>
      </ng-container>
      <ng-container *ngSwitchCase="'search'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
          <path
            d="M22.9 20.9l-6.2-6.1c1.3-1.8 1.9-4 1.6-6.4-.6-3.9-3.8-7.1-7.8-7.4C5 .4.4 5 1 10.5c.3 4 3.5 7.3 7.4 7.8 2.4.3 4.6-.3 6.4-1.5l6.1 6.1c.3.3.7.3 1 0l.9-1c.3-.3.3-.7.1-1zM3.7 9.6c0-3.2 2.7-5.9 5.9-5.9 3.3 0 6 2.7 6 5.9 0 3.3-2.7 6-6 6-3.2 0-5.9-2.6-5.9-6z"/>
        </svg>
      </ng-container>
      <ng-container *ngSwitchCase="'clock'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
          <path
            d="M12 .9C5.9.9.9 5.9.9 12s5 11.1 11.1 11.1 11.1-5 11.1-11.1S18.1.9 12 .9zm0 19.4c-4.6 0-8.3-3.7-8.3-8.3S7.4 3.7 12 3.7s8.3 3.7 8.3 8.3-3.7 8.3-8.3 8.3zm1.6-8.2c-.2-.1-.2-.3-.2-.5V7.2c0-.4-.3-.7-.7-.7h-1.4c-.4 0-.7.3-.7.7v5.5c0 .2.1.4.2.5l3.4 3.5c.3.2.7.2 1 0l1-1c.2-.3.2-.7 0-1l-2.6-2.6z"/>
        </svg>
      </ng-container>
      <ng-container *ngSwitchCase="'close'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
          <path
            d="M14.3 11.7l6-6c.3-.3.3-.7 0-1l-.9-1c-.3-.2-.7-.2-1 0l-6 6.1c-.2.2-.5.2-.7 0l-6-6.1c-.3-.3-.7-.3-1 0l-1 1c-.2.2-.2.7 0 .9l6.1 6.1c.2.2.2.4 0 .6l-6.1 6.1c-.3.3-.3.7 0 1l1 1c.2.2.7.2.9 0l6.1-6.1c.2-.2.4-.2.6 0l6.1 6.1c.2.2.7.2.9 0l1-1c.3-.3.3-.7 0-1l-6-6c-.2-.2-.2-.5 0-.7z"/>
        </svg>
      </ng-container>
      <ng-container *ngSwitchCase="'check'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
          <path
            d="M8.8 19.6L1.2 12c-.3-.3-.3-.8 0-1.1l1-1c.3-.3.8-.3 1 0L9 15.7c.1.2.5.2.6 0L20.9 4.4c.2-.3.7-.3 1 0l1 1c.3.3.3.7 0 1L9.8 19.6c-.2.3-.7.3-1 0z"/>
        </svg>
      </ng-container>
      <ng-container *ngSwitchCase="'date_time'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
          <path
            d="M17.3 6.2h-1.2v-.4c0-.6-.5-1-1-1s-.9.4-.9 1v.4H9.8v-.4c0-.6-.4-1-.9-1s-1 .4-1 1v.4H6.7c-.8 0-1.4.7-1.4 1.5v.5c0 .2.2.4.5.4h12.4c.3 0 .5-.2.5-.4v-.5c0-.8-.6-1.5-1.4-1.5zm.9 3.9H5.8c-.3 0-.5.2-.5.5v7.2c0 .8.6 1.4 1.4 1.4h10.6c.8 0 1.4-.6 1.4-1.4v-7.2c0-.3-.2-.5-.5-.5zM12 18.2c-2 0-3.6-1.6-3.6-3.6s1.6-3.5 3.6-3.5 3.6 1.6 3.6 3.5-1.6 3.6-3.6 3.6zm.4-3.7V13c0-.2-.1-.3-.3-.3h-.2c-.1 0-.3.1-.3.3v1.6c0 .1.1.2.1.3l1.2 1.1c.1.1.2.1.3 0l.2-.1c.1-.1.1-.3 0-.4l-1-1z"/>
        </svg>
      </ng-container>
      <ng-container *ngSwitchCase="'logout'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
          <path
            d="M9.7 22.4V21c0-.4-.3-.7-.7-.7H4.4c-.4 0-.7-.3-.7-.7V4.4c0-.4.3-.7.7-.7H9c.4 0 .7-.3.7-.7V1.6c0-.4-.3-.7-.7-.7H2.8C1.8.9.9 1.8.9 2.8v18.4c0 1 .9 1.9 1.9 1.9H9c.4 0 .7-.3.7-.7zm13.2-9.9c.3-.3.3-.7 0-1l-6.2-6.2c-.3-.3-.7-.3-1 0l-1 .9c-.3.3-.3.7 0 1l2.6 2.6c.3.3.1.8-.3.8H7.2c-.4 0-.7.2-.7.6v1.4c0 .4.3.7.7.7h9.7c.5 0 .6.5.4.8l-2.6 2.6c-.3.3-.3.7 0 1l.9.9c.3.3.7.3 1 0l6.3-6.1z"/>
        </svg>
      </ng-container>

      <ng-container *ngSwitchCase="'x'">
        <svg height="100%" viewBox="0 0 24 24" width="100%">
        </svg>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <use [attr.xlink:href]="href"></use>
      </ng-container>
    </ng-container>
  </svg>
  <span class="slds-assistive-text">{{description}}</span>
</span>
